import CardCategory from "../components/CardCategory";
import IconVeranstaltung from "../assets/veranstaltungen.svg";
import IconSocial from "../assets/social.svg";
import IconDocumentary from "../assets/documentary.svg";
import IconNature from "../assets/nature.svg";
import IconMakingOf from "../assets/makingof.svg";

export default function FotoWrapper() {
  const images = [
    { image: IconVeranstaltung, title: "veranstaltungsfotographie-icon" },
    { image: IconSocial, title: "socialmediafotographie-icon" },
    { image: IconNature, title: "landschaftsfotographie-icon" },
    { image: IconDocumentary, title: "dokumentationsfotographie-icon" },
    { image: IconMakingOf, title: "makingoffotographie-icon" },
  ];

  const cards = [
    {
      titel: "Social Media",
      image: images[1].image
    },
    {
      titel: "Veranstaltungen",
      image: images[0].image
    },
    {
      titel: "Dokumentation",
      image: images[3].image
    },
    {
      titel: "Landschaften",
      image: images[2].image
    },
    {
      titel: "Making Of",
      image: images[4].image
    }
  ];

  return (
    <div className="category-wrapper">
      {cards.map((card, index) => (
        <CardCategory
          key={index} // Add a unique key for each card
          titel={card.titel}
          image={card.image}
        />
      ))}
    </div>
  );
}